var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "_grid _grid-cols-5 _gap-2 _jc-st _pa-3 _pa-5--m",
      attrs: { "data-qa": "backer-center-payments:Skeleton" },
    },
    [
      _c(
        "div",
        { staticClass: "_flexcol _col-span-4 _gap-1" },
        [
          _c("skeleton-line", { attrs: { height: 22 } }),
          _vm._v(" "),
          _c("skeleton-line", { attrs: { height: 18 } }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [_c("skeleton-line", { attrs: { height: 22 } })], 1),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }